// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { ExpertIn } from './expertIn.zod.ts';

export const assetCreateInCountriesOneItemMax = 10;

export const assetCreateInCountriesOneMax = 300;

export const assetCreateInExpertsOneMax = 50;

export const assetCreateInHomeCountryOneMax = 6;

export const assetCreateInIndustryIdsOneMax = 50;

export const assetCreateInNameMax = 120;

export const assetCreateInPartnersOneItemMax = 120;

export const assetCreateInPartnersOneMax = 50;

export const assetCreateInSummaryOneMax = 600;

export const assetCreateInTaglineOneMax = 200;

export const AssetCreateIn = zod.object({
  "countries": zod.union([zod.array(zod.string().max(assetCreateInCountriesOneItemMax)).max(assetCreateInCountriesOneMax),zod.null()]).optional(),
  "experts": zod.union([zod.array(ExpertIn).max(assetCreateInExpertsOneMax),zod.null()]).optional(),
  "home_country": zod.union([zod.string().max(assetCreateInHomeCountryOneMax),zod.null()]).optional(),
  "industry_ids": zod.union([zod.array(zod.uuid()).max(assetCreateInIndustryIdsOneMax),zod.null()]).optional(),
  "kind": zod.enum(['platform', 'accelerator', 'framework', 'offer']),
  "maturity": zod.union([zod.enum(['concept', 'pilot', 'available']),zod.null()]).optional(),
  "name": zod.string().min(1).max(assetCreateInNameMax),
  "partners": zod.union([zod.array(zod.string().max(assetCreateInPartnersOneItemMax)).max(assetCreateInPartnersOneMax),zod.null()]).optional(),
  "summary": zod.union([zod.string().max(assetCreateInSummaryOneMax),zod.null()]).optional(),
  "tagline": zod.union([zod.string().max(assetCreateInTaglineOneMax),zod.null()]).optional()
});

export type AssetCreateIn = zod.input<typeof AssetCreateIn>;
export type AssetCreateInOutput = zod.output<typeof AssetCreateIn>;
